import React, {useEffect, useState} from "react";
import styles from "./Toast.module.scss";

const Toast = ({ title, children, errorCode, show = false }) => {

    const timeLeftInSeconds = 6;

    const [showToast, setShowToast] = useState(false);
    const [timeLeft, setTimeLeft] = useState(timeLeftInSeconds);

    useEffect(() => {
        if (timeLeft < 0 || !show || !showToast) {
            setTimeLeft(timeLeftInSeconds);
            setShowToast(false);
        }
    }, [timeLeft]);

    useEffect(() => {
        if (show) {
            const timeShow = setTimeout(() => {
                setShowToast(show);
            }, 0);
            const timer = window.setInterval(() => {
                setTimeLeft(prevTimeLeft => prevTimeLeft - 1);
            }, 1000);
            return () => {
                window.clearInterval(timer);
                window.clearTimeout(timeShow);
            };
        }
    }, [show])

    const handleCloseToast = () => {
        setShowToast(false);
    }

    return (
        <div className={`${styles.Toast} ${showToast ? styles.show : styles.hide}`}>
            <div className={`${styles.card} d-flex align-items-center justify-content-between`}>
                <div className={'d-flex align-items-center justify-content-center'}>
                    <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M17.307 6.40876C21.0515 5.53041 24.9485 5.53041 28.693 6.40876C34.1005 7.6772 38.3228 11.8995 39.5912 17.307C40.4696 21.0515 40.4696 24.9485 39.5912 28.693C38.3228 34.1005 34.1005 38.3228 28.693 39.5912C24.9485 40.4696 21.0515 40.4696 17.307 39.5912C11.8995 38.3228 7.6772 34.1005 6.40876 28.693C5.53041 24.9485 5.53041 21.0515 6.40876 17.307C7.6772 11.8995 11.8995 7.6772 17.307 6.40876ZM23 19.3304C24.0133 19.3304 24.8347 18.5089 24.8347 17.4956C24.8347 16.4822 24.0133 15.6608 23 15.6608C21.9866 15.6608 21.1652 16.4822 21.1652 17.4956C21.1652 18.5089 21.9866 19.3304 23 19.3304ZM23 20.7065C23.7599 20.7065 24.3761 21.3226 24.3761 22.0826V29.4217C24.3761 30.1817 23.7599 30.7978 23 30.7978C22.24 30.7978 21.6239 30.1817 21.6239 29.4217V22.0826C21.6239 21.3226 22.24 20.7065 23 20.7065Z" fill="#FF0053"/>
                    </svg>
                </div>
                <div>
                    <div className={`${styles.title} d-flex justify-content-between`}>
                        <div>
                            { title }
                        </div>
                        <div onClick={handleCloseToast} className={'d-flex align-items-center'}>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <line x1="0.75" y1="-0.75" x2="12.326" y2="-0.75" transform="matrix(-0.713777 0.700373 -0.713777 -0.700373 12.666 3.27074)" stroke="#C2C7ED" stroke-width="1.5" stroke-linecap="round"/>
                                <path d="M3.95508 3.88126L12.6284 12.3918" stroke="#C2C7ED" stroke-width="1.5" stroke-linecap="round"/>
                            </svg>
                        </div>
                    </div>
                    <div className={styles.text}>
                        { children }
                    </div>
                    <div className={styles.errorCode}>
                        Error Code: { errorCode }
                    </div>
                </div>
                <div className={styles.progressBar}>
                    <span style={{width: `${Math.round((timeLeft * 100) / 6)}%`}}></span>
                </div>
            </div>
        </div>
    )
}

export default Toast;